module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
var _tabEnabled = "";
if(tabEnabled) {
    _tabEnabled = 'checked="true" ';
}


    ; __append("\r\n\r\n<div class=\"prop-header\">\r\n    <span class=\"prop-label\">Tabbing</span>\r\n</div>\r\n<div class=\"nav-tabbing prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">Tab Index</label>\r\n            <div class=\"nopadding form-group-flex\">\r\n                <input type=\"text\" name=\"tabIndex\" class=\"tabIndex label-45\" value=\"")
    ; __append(escapeFn(tabIndex))
    ; __append("\"/>\r\n                <div id=\"propTabStop\" class=\"col-md-6 nopadding-r nopadding-l subsection\" style=\"margin-top: 2px;\">\r\n                    <input type=\"checkbox\" name=\"tabEnabled\" id=\"tabEnabled\" class=\"form-radio-group\" style=\"margin-left: 5px;\">\r\n                    <label class=\"form-group-label\">Tab Stop</label>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div id=\"navTooltip\" class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">Tooltip</label>\r\n            <div>\r\n                <input type=\"text\" name=\"toolTip\" class=\"tooltipInput ")
    ; __append(escapeFn(toolTip !== '' ? 'translatable' : '' ))
    ; __append("\" data-attr=\"toolTip\" value=\"")
    ; __append(escapeFn(toolTip))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}